import { createSlice } from '@reduxjs/toolkit'


export const tableSlice = createSlice({
  name: 'tableEdu',
  initialState: {
    data:[],
    filterdata:[],
    searchdate:''
  },
  reducers: {
    
      setDataRedux: (state, action) => {
        const { data } = action.payload
        state.data = data
      },
      setDataDetailsRedux: (state, action) => {
        const { datadetails,index } = action.payload
        const newTime = new Date(datadetails.updatedAt)
        const options = {
          year: "2-digit",
          month: "numeric",
          day: "numeric",
        };
        datadetails.updatedAt = newTime.toLocaleDateString('th',options);
        state.data[index] = {...state.data[index],...datadetails}
        state.filterdata[index] = {...state.filterdata[index],...datadetails}
      },
      setFilterDataRedux: (state, action) => {
        const { filterdata } = action.payload
        state.filterdata = filterdata
      },
      setSearchDateRedux: (state, action) => {
        
        const { filterdata } = action.payload
        state.filterdata = filterdata
      },
  },
})

export default tableSlice.reducer;

export const {
    setDataRedux,
    setDataDetailsRedux,
    setFilterDataRedux,
    setSearchDateRedux
    
} = tableSlice.actions

export const getDataRedux = (state) => state.tableEdu.data
export const getFilterDataRedux = (state) => state.tableEdu.filterdata
export const getSearchDateRedux = (state) => state.tableEdu.searchdate






